module.exports = __webpack_public_path__ + "static/media/SteveYoung_2026.4853a0f7.jpg";